function updateDiscountBadges() {
  document.querySelectorAll(".product-badges__badge").forEach(function (badge) {
    const card = badge.closest("product-card, .card-wrapper, li");
    if (!card) return;

    const comparePriceEl = card.querySelector(".compare-at-price");
    const salePriceEl = card.querySelector("span.price");

    if (!comparePriceEl || !salePriceEl) {
      badge.textContent = "";
      badge.style.display = "none";
      return;
    }

    const parse = (el) =>
      parseFloat(el.textContent.replace(/[^0-9,]/g, "").replace(",", "."));

    const originalPrice = parse(comparePriceEl);
    const salePrice = parse(salePriceEl);

    if (originalPrice > salePrice && salePrice > 0) {
      const discount = Math.round(((originalPrice - salePrice) / originalPrice) * 100);
      badge.textContent = discount + "% RABATT";
      badge.style.display = "";
    } else {
      badge.textContent = "";
      badge.style.display = "none";
    }
  });
}

document.addEventListener("DOMContentLoaded", updateDiscountBadges);
setTimeout(updateDiscountBadges, 1000);
setTimeout(updateDiscountBadges, 2500);
window.addEventListener("pageshow", updateDiscountBadges);
window.addEventListener("popstate", updateDiscountBadges);

// Nur auf Produktseiten
function updateProductPageBadge() {
  if (!window.location.pathname.includes("/products/")) return;
  if (document.querySelector(".zirella-discount-badge")) return;

  const productPrice = document.querySelector("product-price");
  if (!productPrice) return;

  const priceEl = productPrice.querySelector("span.price");
  const comparePriceEl = productPrice.querySelector(".compare-at-price");

  if (!priceEl || !comparePriceEl) return;

  const parse = (el) =>
    parseFloat(el.textContent.replace(/[^0-9,]/g, "").replace(",", "."));

  const salePrice = parse(priceEl);
  const originalPrice = parse(comparePriceEl);

  if (originalPrice > salePrice && salePrice > 0) {
    const discount = Math.round(((originalPrice - salePrice) / originalPrice) * 100);

    const badge = document.createElement("div");
    badge.className = "zirella-discount-badge";
    badge.textContent = discount + "% RABATT";
    badge.style.cssText = `
      display: inline-block;
      background: #000000;
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      padding: 6px 14px;
      border-radius: 4px;
      margin-bottom: 10px;
    `;
    productPrice.parentNode.insertBefore(badge, productPrice);
  }
}

document.addEventListener("DOMContentLoaded", updateProductPageBadge);
setTimeout(updateProductPageBadge, 500);
setTimeout(updateProductPageBadge, 1500);
// Für "Das könnte dir auch gefallen" - verzögert nachladen
setTimeout(updateDiscountBadges, 4000);
setTimeout(updateDiscountBadges, 6000);